import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function ThreeHero() {
  const line1 = 'Find your';
  const line2 = 'next AI app';
  const fullText = line1 + ' ' + line2;
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  useEffect(() => {
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(fullText.slice(0, currentIndex + 1));
        setCurrentIndex(currentIndex + 1);
      }, 80); // 80ms per character for natural typing speed
      return () => clearTimeout(timeout);
    } else {
      setIsComplete(true);
    }
  }, [currentIndex, fullText]);
  // Split displayed text into two lines at "your "
  const splitPoint = line1.length;
  const firstLine = displayedText.slice(0, Math.min(displayedText.length, splitPoint));
  const secondLine = displayedText.slice(splitPoint).trim();
  const showCursor = !isComplete && displayedText.length >= splitPoint;
  return <section className="relative h-[35vh] w-full overflow-hidden" data-id="element-558">
      {/* Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-4" data-id="element-559">
        <motion.h1 initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3
      }} className="text-5xl md:text-7xl lg:text-8xl mb-6 leading-tight text-white font-hero" data-id="element-560">
          {firstLine}
          <br data-id="element-561" />
          {secondLine}
          {showCursor && <motion.span animate={{
          opacity: [1, 0]
        }} transition={{
          duration: 0.8,
          repeat: Infinity,
          repeatType: 'reverse'
        }} className="inline-block w-1 h-[0.9em] bg-cyan-400 ml-1 align-middle" data-id="element-562" />}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: fullText.length * 0.08 + 0.2
      }} className="text-gray-400 font-special max-w-[90%] md:max-w-none md:whitespace-nowrap" data-id="element-563">
          Explore the best AI tools with real pricing data and updates.
        </motion.p>
      </div>
    </section>;
}